import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/core/Navbar';
import Footer from '../../components/core/Footer';
import './InfoPage.css';

const InfoPage = () => {
  return (
    <>
      <Navbar />
      <div className="info-page">
        {/* Hero Section */}
        <section className="info-hero">
          <div
            className="info-hero-background"
            style={{
              backgroundImage: `url('/assets/info_hero.png')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="container">
              <h1>Learn About Numerease and the Numerai Tournament</h1>
              <p className="hero-subheadline">
                Discover how we're making quantitative finance accessible to everyone
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="info-content">
          <div className="container">
            <div className="content-section">
              <p className="intro-text">
                Welcome to Numerease - your gateway to participating in the Numerai Tournament. 
                We provide tools and insights to help you build and optimize your machine learning models 
                for this unique data science competition.
              </p>
            </div>

            <div className="info-cards">
              <Link to="/info/what-is-the-numerai-tournament" className="info-card">
                <h2>What is the Numerai Tournament?</h2>
                <p>Learn about this innovative data science competition that's revolutionizing quantitative finance.</p>
              </Link>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default InfoPage; 